import { useEffect, useState } from 'react';
import { Controller, useForm, FormProvider } from "react-hook-form";
import PacmanLoader from "react-spinners/PacmanLoader";
import "bootstrap/dist/css/bootstrap.min.css";
import { DefaultMemberViewModel, MemberViewModel } from '../models/member/MemberViewModel'
import MembershipController from "../controllers/MembershipController"
import EditMemberCommand from '../models/member/EditMemberCommand';
import { useParams } from 'react-router-dom';
import { Card } from "react-bootstrap";
import { ErrorMessage } from '@hookform/error-message';
import CameraComponent from './CameraComponent'
import FingerprintReader, { b64UrlTob64 } from './FingerprintReader'
import { SamplesAcquired } from '@digitalpersona/devices';
import moment from 'moment'

export default function EditMember() {
    let { memberId } = useParams<{ memberId: string }>();
    const [numberOfFingerprints, setNumberOfFingerprints] = useState(0);
    const [loading, setLoading] = useState(true);
    const [member, setMember] = useState<MemberViewModel>();
    var membershipController = new MembershipController();
    const methods = useForm<EditMemberCommand>({ defaultValues: { Member: DefaultMemberViewModel() } });
    const { control,
        register,
        handleSubmit,
        getValues,
        reset,
        setValue,
        setError,
        clearErrors,
        formState: { errors }
    } = methods;

    useEffect(() => {
        if (member == null) {
            getMember();
        }
    })

    const fingerprintReader = new FingerprintReader();

    const beginAcquisition = () => {
        setNumberOfFingerprints(0);
        fingerprintReader.samplesAcquired = (sample: SamplesAcquired) => { sampleAcquired(sample) };
        fingerprintReader.startAcquiring();
    }

    const getMember = async () => {
        var result = await membershipController.GetMembership(memberId)
        console.log(result)
        if (result != null) {
           /* var date = moment(result.DateOfBirth).format("yyyy-MM-DD");
            setMember(result);
            setValue('Member.Id', result.Id)
            setValue('Member.Firstname', result.Firstname)
            setValue('Member.Surname', result.Surname)
            setValue('Member.Email', result.Email)
            setValue('Member.DateOfBirth', date)
            setValue('Member.PhoneNumber', result.PhoneNumber)
            setValue('Member.Address1', result.Address1)
            setValue('Member.Address2', result.Address2)
            setValue('Member.Town', result.Town)
            setValue('Member.Postcode', result.Postcode)
            setValue('Member.AddressPicture', result.AddressPicture)
            setValue('Member.DataProtectionAgreed', result.DataProtectionAgreed)
            setValue('Member.HoldInformationAgreed', result.HoldInformationAgreed)
            setValue('Member.MarketingOptIn', result.MarketingOptIn)*/
        }
        setLoading(false);
    }

    const sampleAcquired = (sample: SamplesAcquired) => {
        var data = b64UrlTob64(sample.samples[0].Data.toString());
        try {
            var fingerprints = getValues(`Member.Thumbprints`);
            if (fingerprints.length >= 4) {
                return;
            }
            clearErrors(`Member.Thumbprints`)
            fingerprints.push(data);
            setValue(`Member.Thumbprints`, fingerprints);
            setNumberOfFingerprints(fingerprints.length);
        }
        catch (err) {
            console.log(err)
        }
    }

    const onSubmit = async (data: EditMemberCommand) => {
        var result = false;
        if (!(member && member.HasFingerprint)) {
            if (!data.Member.Thumbprints || data.Member.Thumbprints.length == 0) {
                result = window.confirm("Are you sure you don't want to capture any fingerprints?");
            }
            else {
                result = true;
            }

        }
        else {
            result = true;
        }
        if (result) {
            try {
             //   var editResult = await memberController.EditMember(data, setError);
               // if (editResult) {
                //    window.location.href = ("/");
               // }
            }
            catch (err) {
                console.log(err);
            }
        }
    };

    if (loading) {
        return <div className="col-6 mx-auto text-center"><PacmanLoader color="#947a27" /></div>
    }


    return (
        <>
            {member &&
                <div className="col-12 mx-auto">
                    <h1 className="text-center">Edit Member</h1>
                    <br />
                    <FormProvider {...methods}>

                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="mb-3">
                                <Card className="mb-3 bg-dark">
                                    <Card.Body>
                                        <div className="row">
                                            <div className="col">
                                                <div className="form-floating mb-3">
                                                    <input {...register(`Member.Firstname`)} type="text" className="form-control" placeholder="First Name" />
                                                    <label htmlFor="floatingInput" className="text-dark">First Name</label>
                                                    <p className="text-danger"><ErrorMessage errors={errors} name={`Member.Firstname`} /></p>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="form-floating mb-3">
                                                    <input {...register(`Member.Surname`)} type="text" className="form-control" placeholder="Last Name" />
                                                    <label htmlFor="floatingInput" className="text-dark">Last Name</label>
                                                    <p className="text-danger"><ErrorMessage errors={errors} name={`Member.Surname`} /></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <div className="form-floating mb-3">
                                                    <input {...register(`Member.Email`)} type="text" className="form-control" placeholder="Email" />
                                                    <label htmlFor="floatingInput" className="text-dark">Email</label>
                                                    <p className="text-danger"><ErrorMessage errors={errors} name={`Member.Email`} /></p>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="form-floating mb-3">
                                                    <input {...register(`Member.PhoneNumber`)} type="text" className="form-control" placeholder="Phone Number" />
                                                    <label htmlFor="floatingInput" className="text-dark">Phone Number</label>
                                                    <p className="text-danger"><ErrorMessage errors={errors} name={`Member.PhoneNumber`} /></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-floating mb-3">
                                                    <input {...register(`Member.DateOfBirth`)} type="date" className="form-control" placeholder="Date of Birth" />
                                                    <label htmlFor="floatingInput" className="text-dark">Date of Birth</label>
                                                    <p className="text-danger"><ErrorMessage errors={errors} name={`Member.DateOfBirth`} /></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="form-floating mb-3">
                                                            <input {...register(`Member.Address1`)} type="text" className="form-control" placeholder="Address 1" />
                                                            <label htmlFor="floatingInput" className="text-dark">Address 1</label>
                                                            <p className="text-danger"><ErrorMessage errors={errors} name={`Member.Address1`} /></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <div className="form-floating mb-3">
                                                        <input {...register(`Member.Address2`)} type="text" className="form-control" placeholder="Address 2" />
                                                        <label htmlFor="floatingInput" className="text-dark">Address 2</label>
                                                        <p className="text-danger"><ErrorMessage errors={errors} name={`Member.Address2`} /></p>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="form-floating mb-3">
                                                            <input {...register(`Member.Town`)} type="text" className="form-control" placeholder="Town" />
                                                            <label htmlFor="floatingInput" className="text-dark">Town</label>
                                                            <p className="text-danger"><ErrorMessage errors={errors} name={`Member.Town`} /></p>
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        <div className="form-floating mb-3">
                                                            <input {...register(`Member.Postcode`)} type="text" className="form-control" placeholder="Postcode" />
                                                            <label htmlFor="floatingInput" className="text-dark">Postcode</label>
                                                            <p className="text-danger"><ErrorMessage errors={errors} name={`Member.Postcode`} /></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <Controller control={control}
                                                name={`Member.AddressPicture`}
                                                render={({ field: { onChange } }) => (
                                                    <CameraComponent image={member.AddressPicture} imageUpdated={onChange} />

                                                )} />
                                        </div>
                                        <div className="row">
                                            <div className="col-6 text-center">
                                                {!member.HasFingerprint &&
                                                    <>
                                                        {getValues(`Member.Thumbprints`) &&
                                                            <h2>{4 - getValues(`Member.Thumbprints`).length} more fingerprints required</h2>}
                                                        {!getValues(`Member.Thumbprints`) &&
                                                            <h2>4 more fingerprints required</h2>}
                                                        {(!getValues(`Member.Thumbprints`) || getValues(`Member.Thumbprints`).length == 0) &&
                                                            <button type="button" className="btn btn-lg btn-light" onClick={() => beginAcquisition()}>Capture Fingerprints</button>
                                                        }

                                                        <br /><p className="text-danger"><ErrorMessage errors={errors} name={`Member.thumbprints`} /></p>
                                                    </>}
                                            </div>
                                            <div className="col-6">
                                                <div className="mb-3 form-check">
                                                    <input {...register(`Member.DataProtectionAgreed`)} type="checkbox" className="form-check-input" />
                                                    <label className="form-check-label">Data protection policy accepted?</label>
                                                    <br /><p className="text-danger"><ErrorMessage errors={errors} name={`Member.DataProtectionAgreed`} /></p>
                                                </div>
                                                <div className="mb-3 form-check">
                                                    <input {...register(`Member.HoldInformationAgreed`)} type="checkbox" className="form-check-input" />
                                                    <label className="form-check-label">Consent to hold information given?</label>
                                                    <br /><p className="text-danger"><ErrorMessage errors={errors} name={`Member.HoldInformationAgreed`} /></p>
                                                </div>
                                                <div className="mb-3 form-check">
                                                    <input {...register(`Member.MarketingOptIn`)} type="checkbox" className="form-check-input" />
                                                    <label className="form-check-label">Happy to recieve marketing information?</label>
                                                    <br /><p className="text-danger"><ErrorMessage errors={errors} name={`Member.MarketingOptIn`} /></p>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                                <button className="btn btn-lg btn-light float-end" type="submit">Submit</button>
                            </div>
                        </form>
                    </FormProvider>
                </div >
            }
        </>
    );
}